export const KPI_PERIOD_NAME_MAP={
  quarter1: {
    nameEn: 'Q1',
    nameCn: 'Q1'
  },
  quarter2: {
    nameEn: 'Q2',
    nameCn: 'Q2'
  },
  quarter3: {
    nameEn: 'Q3',
    nameCn: 'Q3'
  },
  quarter4: {
    nameEn: 'Q4',
    nameCn: 'Q4'
  },
  year: {
    nameEn: 'Total',
    nameCn: '总'
  },
};

export const LABEL_PERIOD_NAME_MAP={
  quarter: {
    nameEn: 'Quarterly',
    nameCn: '季度'
  },
  year: {
    nameEn: 'Yearly',
    nameCn: '年度'
  },
};